import '../types/window';

enum Platform {
  WEB = 'web',
  NATIVE_MOBILE_IOS = 'ios',
  NATIVE_MOBILE_ANDROID = 'android',
}

export function getPlatform(): Platform {
  if (typeof window !== 'undefined' && window.PP_APP_INFO) {
    const {platform} = window.PP_APP_INFO;
    if (platform === 'ios') {
      return Platform.NATIVE_MOBILE_IOS;
    }
    if (platform === 'android') {
      return Platform.NATIVE_MOBILE_ANDROID;
    }
  }

  return Platform.WEB;
}

export function isNativeMobile(): boolean {
  return getPlatform() !== Platform.WEB;
}
